import { useEffect, useState } from "react";

function useSearchQuery() {
    const [query, setQuery] = useState<string>("");
    const [debouncedQuery, setDebouncedQuery] = useState("");

    useEffect(() => {
        const t = setTimeout(() => {
            setDebouncedQuery(query);
        }, 300);

        return () => clearTimeout(t);
    }, [query]);

    return { query, setQuery, debouncedQuery };
}

export default useSearchQuery;